export default "__VITE_ASSET__DyLQHe53__"